function walkGameWalker(conf,mapObj,resources){
    PIXI.Container.call(this);
    conf=$.extend(true,{
        speed:100,
        cell_size:10,
        anims_arr:["animation"],
        bar:{width:60},
        onFail:function(){}
    },conf);
    this.conf=conf;
    this.mapObj=mapObj;
    this.nextDirection=[0,0];
    this.direction=-1;
    this.delta_sum=0;
    this.step_sum=0;
    this.pos=[0,0];
    this.pos_type="s";
    this.dir=[0,0];
    this.speed=conf.speed/1000;
    this.mode="wait";//step,safe,wait
    this.path_start=[0,0];
    this.pathToClear=0;
    //myPixiElement.spine
    this.spineEl=new myPixiElement.spine({
        img:"dron",
        spine_conf:{
            anim_loop:true,
            anim_name:conf.anims_arr[0],
            spineResource:resources
        }
    });
    
//    this.spineEl.scale.set(0.5);
    this.addChild(this.spineEl);
    
    
    
    this.respawn={xy_start:[],dir:[],step:0,step_max:0,opacity_step_max:80,opacity_modulo:20};
    
    this.pathToCheckArr=[];
    
    this.eventCont=new PIXI.Container();
    this.eventCont.x=-30;
    this.eventCont.y=30;
    this.eventCont.alpha=0;
    
    var eventBorder=new PIXI.Graphics();
    eventBorder.beginFill(0x000000);
    eventBorder.drawRect(0, 0, this.conf.bar.width, 4); // drawRect(x, y, width, height)
    eventBorder.endFill(eventBorder);
    eventBorder.alpha=0.2;
    
    this.eventBar = new PIXI.Graphics();
    this.eventBar.beginFill(0x9b59b6); // Purple
    this.eventBar.drawRect(0, 0, this.conf.bar.width, 4); // drawRect(x, y, width, height)
    this.eventBar.endFill(this.eventBar);
    
    
    this.eventCont.addChild(eventBorder);
    this.eventCont.addChild(this.eventBar);
    this.addChild(this.eventCont);
    
    
}
walkGameWalker.prototype = Object.create(PIXI.Container.prototype);
walkGameWalker.prototype=$.extend(walkGameWalker.prototype,{
    changeDirection:function(val){
        if(this.respawn.step_max!=0){
            return false;
        }
        this.nextDirection=val;
    },
    tryChangeDirection:function(){
        
        if(this.nextDirection[0]==0 && this.nextDirection[1]==0){
            return false;
        }
        var nextDirection=copyArray(this.nextDirection);
        this.nextDirection=[0,0];
        if(this.mode=="step" && this.dir[0]==-nextDirection[0] && this.dir[1]==-nextDirection[1]){
            return false;//nie zawracaj ze sciezka
        }
        if(this.dir[0]==nextDirection[0] && this.dir[1]==nextDirection[1]){
            return false;//powtórka
        }
        
        var pos_next=[this.pos[0]+nextDirection[0],this.pos[1]+nextDirection[1]];
        var pos_type_next=this.mapObj.takeField(pos_next);
        
        if(pos_type_next=='none'){
            return false;
        }
        this.dir=nextDirection;
        return true;
//        $.qLog("<br>DIR:["+nextDirection[0]+","+nextDirection[1]+"]<br>");
//        this.step_sum=0;
    },
    tryClearPath:function(){
        if(this.pathToClear){
            this.pathToClear=0;
            return 1;
        }
        return 0;
    },
    prepareRespawn:function(xy_start,pos_end){
//        this.respawn={xy_start:[],dir:[],step:0,step_max:0};
           
           this.respawn.xy_start=copyArray(xy_start);
           var xy=this.mapObj.takeXY(pos_end);
           this.respawn.dir=minusVector(xy,this.respawn.xy_start);
           var speed=this.countSpeed();
           this.respawn.step=0;
           this.respawn.step_max=lengthVector(this.respawn.dir)*speed+this.respawn.opacity_step_max;
           this.alpha=0.3;
           

    },
    endPath:function(state,type_id){
        if(this.respawn.step_max!=0){
            return false;
        }
        this.dir=[0,0];
        this.mode="wait";
        this.nextDirection=[0,0];
        this.step_sum=0;
        if(state=="fail"){
            this.prepareRespawn([this.x,this.y],this.path_start);
            this.pos=copyArray(this.path_start);
            this.pos_type=this.mapObj.takeField(this.pos);
            this.mapObj.clearPath();
            
            
            
            this.conf.onFail(type_id);
        }
        else{
            this.pathToClear=1;
        }
        
    },
    stopWalk:function(){
        if(this.mode!="step"){
            this.nextDirection="stop";
        }
        
    },
    countSpeed:function(){
        return this.conf.speed/1000;
    },
    continueWalk:function(){
        if(this.nextDirection=="stop"){
            this.nextDirection=[0,0];
        }
        
        this.speed=this.countSpeed();
    },
    checkPathWithSecurity:function(){
        if(this.pathToCheckArr.length){
            var arr=copyArray(this.pathToCheckArr);
            this.pathToCheckArr=[];
            return arr;
        }
        return [];
    },
    myUpdateRespawn:function(delta){
        if(this.respawn.step_max==0){
            return false;
        }
        this.respawn.step+=delta;
        var move_max=this.respawn.step_max-this.respawn.opacity_step_max;
        var opacity_step=0;
        
        
        var part=this.respawn.step/move_max;
        if(part>1){
            part=1;
            var opacity_step=this.respawn.step-move_max;
            if(opacity_step%this.respawn.opacity_modulo<this.respawn.opacity_modulo/2){
                this.alpha=1;
            }
            else{
                this.alpha=0.3;
            }
            
        }
        
        
        if(this.respawn.step>=this.respawn.step_max){
            this.respawn.step=this.respawn.step_max;
            part=1;
            this.respawn.step_max=0;
            this.alpha=1;
        }
        
        this.x=this.respawn.xy_start[0]+this.respawn.dir[0]*part;
        this.y=this.respawn.xy_start[1]+this.respawn.dir[1]*part;
        
        return true;
    },
    setLive:function(live,live_max){
        var live_show=live_max-live;
        live_show=Math.min(live_show,this.conf.anims_arr.length-1);
        live_show=Math.max(0,live_show);
        var anim_name=this.conf.anims_arr[live_show];
        this.spineEl.playAnim(anim_name);
    },
    takeEventPos:function(){
        return {pos:[this.pos[0],this.pos[1]],xy:[this.x,this.y]};
    },
    myUpdate:function(delta){
        if(this.myUpdateRespawn(delta)){
            return true;
        }
        
        this.delta_sum+=delta;
        this.step_sum+=delta*this.speed;
        
        var steps_full=Math.floor(this.step_sum);
        
        var i;
        var path_to_check=0;
        
        if(steps_full>0){
            for(i=0;i<steps_full;i++){
                //ile pelnych krokow
                var pos_type_prev=this.pos_type;
                if(this.mode=="step"){
                    pos_type_prev=this.mapObj.takeField(this.pos);
                }
                this.pos=[this.pos[0]+this.dir[0],this.pos[1]+this.dir[1]];
                if(this.dir[0]!=0 || this.dir[1]!=0){
//                    $.qLog("clear("+this.pos[0]+","+this.pos[1]+")<br>");
                }
                this.pos_type=this.mapObj.takeField(this.pos);
                if(i==0){
                    
                    if(this.nextDirection=="stop"){
                        this.speed=0;
                        this.nextDirection=[0,0];
                        this.step_sum=steps_full;
                        this.dir=[0,0];
                    }
                    else{
                        if(this.tryChangeDirection()){
                            i=steps_full-1;
                        }
                    }
                    
                    
                    
                }
                
                
                var pos_next=[this.pos[0]+this.dir[0],this.pos[1]+this.dir[1]];
                var pos_type_next=this.mapObj.takeField(pos_next);
                
                
                if(pos_type_next=="none"){
                    this.mode="wait";
                    this.dir=[0,0];
                    this.nextDirection=[0,0];
                }
                
                
                if(pos_type_next=="s" && this.pos_type=="s" && (this.dir[0]!=0 || this.dir[1]!=0)){
                    this.mode="move";
                }
                
                if(pos_type_prev=="w" && this.pos_type=="s"){
                    this.endPath();
                    //end path
                    path_to_check=0;
                }
                else if(pos_type_prev=="w" && this.pos_type=="w"){
                    this.endPath("fail",1);
                    path_to_check=0;
                }
                else if(this.mode=="step"){
                    this.mapObj.addPath(this.path_start,copyArray(this.pos),copyArray(this.dir));
//                    this.pathToCheckArr.push(copyArray(this.pos));
                    path_to_check=1;
                    //add to path
                }
                else if(this.pos_type=="s" && pos_type_next=="d"){
                    //start path
                    this.path_start=copyArray(this.pos);
                    this.mode="step";
                    path_to_check=0;
                    _moduleEvents.trigger("walksound","drone_start");
                }
            }
            
            
            this.step_sum-=steps_full;
            
            
            
        }
        
        
        this.x=(this.pos[0]+this.step_sum*this.dir[0])*this.conf.cell_size;
        this.y=(this.pos[1]+this.step_sum*this.dir[1])*this.conf.cell_size;
        if(path_to_check==1){
            this.pathToCheckArr.push([this.x,this.y]);
        }
        
        
    },
    startBar:function(){
        this.eventCont.alpha=1;
        this.eventBar.width=this.conf.bar.width;
    },
    stopBar:function(){
        this.eventCont.alpha=0;
    },
    updateBar:function(part){
        this.eventBar.width=part*this.conf.bar.width;
        
    }
});